import type {IssueArtifact, IssueArtifactType} from './types'

/** Render order for artifact groups so same-typed artifacts always cluster together. */
const TYPE_ORDER: Record<IssueArtifactType, number> = {
  plan: 0,
  generic: 1,
  link: 2,
}

/**
 * Clusters artifacts by type (plans, then docs, then links) while preserving the
 * original relative order within each group. Ensures a newly added artifact lands
 * next to others of its kind instead of being interspersed.
 */
export function groupArtifactsByType(artifacts: IssueArtifact[]): IssueArtifact[] {
  return artifacts
    .map((artifact, index) => ({artifact, index}))
    .sort((a, b) => TYPE_ORDER[a.artifact.type] - TYPE_ORDER[b.artifact.type] || a.index - b.index)
    .map(({artifact}) => artifact)
}
